export default __webpack_public_path__ + "static/media/ai_virtual_services_generate_en.312ae563.png";